import { render, staticRenderFns } from "./NetDownSimCards.vue?vue&type=template&id=c2098f86&"
import script from "./NetDownSimCards.vue?vue&type=script&lang=js&"
export * from "./NetDownSimCards.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports